"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlToSlate = void 0;

var slate_hyperscript_1 = require("slate-hyperscript");

var htmlparser2_1 = require("htmlparser2");

var domhandler_1 = require("domhandler");

var domutils_1 = require("domutils");

var css_select_1 = require("css-select");

var default_1 = require("./config/default");

var whitespace_1 = require("./whitespace");

var blocks_1 = require("../../utilities/blocks");

var deserialize = function deserialize(_ref) {
  var el = _ref.el,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? default_1.config : _ref$config,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      _ref$childrenLength = _ref.childrenLength,
      childrenLength = _ref$childrenLength === void 0 ? 0 : _ref$childrenLength,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? '' : _ref$context;

  var _a, _b;

  if (el.type !== htmlparser2_1.ElementType.Tag && el.type !== htmlparser2_1.ElementType.Text) {
    return null;
  }

  var currentEl = el;
  var nodeName = (0, domutils_1.getName)(currentEl);
  var childrenContext = (0, whitespace_1.getContext)(nodeName) || context;
  var isLastChild = index === childrenLength - 1;
  var isWithinTextNodes = ((_a = currentEl.prev) === null || _a === void 0 ? void 0 : _a.type) === htmlparser2_1.ElementType.Text && ((_b = currentEl.next) === null || _b === void 0 ? void 0 : _b.type) === htmlparser2_1.ElementType.Text;

  if (nodeName === 'br' && config.convertBrToLineBreak && context !== 'preserve') {
    return [(0, slate_hyperscript_1.jsx)('text', {
      text: context ? '\n' : ''
    }, [])];
  }

  var children = currentEl.childNodes ? currentEl.childNodes.map(function (node, i) {
    return deserialize({
      el: node,
      config: config,
      index: i,
      childrenLength: currentEl.childNodes.length,
      context: childrenContext
    });
  }).filter(function (element) {
    return element;
  }).filter(function (element) {
    return !isSlateDeadEnd(element);
  }).map(function (element) {
    return addTextNodeToEmptyChildren(element);
  }).flat() : [];

  if ((0, domutils_1.getName)(currentEl) === 'body') {
    return (0, slate_hyperscript_1.jsx)('fragment', {}, children);
  }

  if (config.elementTags[nodeName]) {
    var attrs = config.elementTags[nodeName](currentEl);

    if (config.elementAttributeTransform) {
      attrs = Object.assign(Object.assign({}, attrs), config.elementAttributeTransform({
        el: currentEl
      }));
    }

    return (0, slate_hyperscript_1.jsx)('element', attrs, children);
  }

  if (config.textTags[nodeName] || el.type === htmlparser2_1.ElementType.Text) {
    var _attrs = gatherTextMarkAttributes({
      el: currentEl,
      config: config
    });

    var text = (0, whitespace_1.processTextValue)({
      text: (0, domutils_1.textContent)(el),
      context: childrenContext,
      isInlineStart: index === 0,
      isInlineEnd: Number.isInteger(childrenLength) && isLastChild,
      isNextSiblingBlock: el.next && (0, domhandler_1.isTag)(el.next) && (0, blocks_1.isBlock)(el.next.tagName) || false,
      shouldTrimWhiteSpace: config.trimWhiteSpace
    });

    if (text === '') {
      return null;
    }

    if ((0, whitespace_1.isAllWhitespace)(text)) {
      if (config.filterWhitespaceNodes && !childrenContext) {
        return null;
      }

      if (config.convertBrToLineBreak) {
        if (currentEl.prev && (0, domutils_1.getName)(currentEl.prev) === 'br') {
          return null;
        }

        if (currentEl.next && (0, domutils_1.getName)(currentEl.next) === 'br') {
          return null;
        }
      }
    }

    return [(0, slate_hyperscript_1.jsx)('text', Object.assign(Object.assign({}, _attrs), {
      text: text
    }), [])];
  }

  return children;
};

var gatherTextMarkAttributes = function gatherTextMarkAttributes(_ref2) {
  var el = _ref2.el,
      _ref2$config = _ref2.config,
      config = _ref2$config === void 0 ? default_1.config : _ref2$config;
  var allAttrs = {};
  var children = (0, domutils_1.getChildren)(el);

  if (children.length) {
    ;
    [el].concat(_toConsumableArray(children.flat())).forEach(function (child) {
      var name = (0, domutils_1.getName)(child);
      var attrs = config.textTags[name] ? config.textTags[name](child) : {};
      allAttrs = Object.assign(Object.assign({}, allAttrs), attrs);
    });

    if (children.length === 1 && (0, domutils_1.getChildren)(children[0]).length) {
      allAttrs = Object.assign(Object.assign({}, allAttrs), gatherTextMarkAttributes({
        el: children[0],
        config: config
      }));
    }
  } else {
    var name = (0, domutils_1.getName)(el);
    var attrs = config.textTags[name] ? config.textTags[name](el) : {};
    allAttrs = Object.assign({}, attrs);
  }

  return allAttrs;
};

var htmlToSlate = function htmlToSlate(html) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : default_1.config;
  var slateContent = [];
  var handler = new domhandler_1.DomHandler(function (error, dom) {
    if (error) {// Handle error
    } else {
      var updaters = config.htmlUpdaterMap ? Object.entries(config.htmlUpdaterMap) : [];

      var _iterator = _createForOfIteratorHelper(updaters),
          _step;

      try {
        var _loop = function _loop() {
          var _step$value = _slicedToArray(_step.value, 2),
              selector = _step$value[0],
              updater = _step$value[1];

          (0, css_select_1.selectAll)(selector, dom).forEach(function (element) {
            if ((0, domhandler_1.isTag)(element)) {
              var updated = updater(element);

              if (updated !== null && updated !== element) {
                if (typeof updated === 'string') {
                  (0, domutils_1.replaceElement)(element, (0, htmlparser2_1.parseDocument)(updated));
                } else {
                  (0, domutils_1.replaceElement)(element, updated);
                }
              }
            }
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      slateContent = dom.map(function (node) {
        return deserialize({
          el: node,
          config: config
        });
      }) // run the deserializer
      .filter(function (element) {
        return element;
      }) // filter out null elements
      .map(function (element) {
        // ensure all top level elements have a children property
        if (!element.children) {
          return {
            children: element
          };
        }

        return element;
      }).filter(function (element) {
        return !isSlateDeadEnd(element);
      }).map(function (element) {
        return addTextNodeToEmptyChildren(element);
      });
    }
  });
  var parser = new htmlparser2_1.Parser(handler, {
    decodeEntities: true
  });
  var updatedHtml = html;

  if (config.htmlPreProcessString instanceof Function) {
    updatedHtml = config.htmlPreProcessString(html);
  }

  parser.write(updatedHtml);
  parser.end();
  return slateContent;
};

exports.htmlToSlate = htmlToSlate;

var isSlateDeadEnd = function isSlateDeadEnd(element) {
  var keys = Object.keys(element);
  if (!('children' in element)) return false;
  return element.children.length === 0 && keys.length === 1;
};

var addTextNodeToEmptyChildren = function addTextNodeToEmptyChildren(element) {
  var keys = Object.keys(element);
  if (!('children' in element)) return element;

  if (element.children.length === 0) {
    element.children.push({
      text: ''
    });
  }

  return element;
};